import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Tab, Tabs } from '@node-space/ui-components'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { useMappedRoles } from 'hooks/useMappedRoles'
import Channels from 'pages/Channels/Channels'
import { TransactionHistory } from 'pages/TransactionHistory/TransactionHistory'
import { CryptoPayments } from './CryptoPayments'
import { PaymentsTabId } from './types'

export const Payments = () => {
  const { t } = useTranslation()
  const { enableUsLaunchRestrictions, enableConsolidatedPayments } = useFeatureFlags()
  const permissions = useMappedRoles()
  const canViewWallets = permissions?.wallets?.canView

  const defaultTab = canViewWallets
    ? PaymentsTabId.TRANSACTION_HISTORY
    : PaymentsTabId.CRYPTO_PAYMENTS

  const tabs: Tab[] = useMemo(() => {
    const tabList: Tab[] = []

    if (canViewWallets) {
      tabList.push({
        id: PaymentsTabId.TRANSACTION_HISTORY,
        header: t('wallets.transactionHistory'),
        content: <TransactionHistory />,
        testId: 'tab-transaction-history',
      })
    }

    tabList.push({
      id: PaymentsTabId.CRYPTO_PAYMENTS,
      header: t('sidebar.cryptoPayments'),
      content: <CryptoPayments />,
      testId: 'tab-crypto-payments',
    })

    if (!enableUsLaunchRestrictions) {
      tabList.push({
        id: PaymentsTabId.CHANNEL_PAYMENTS,
        header: t('sidebar.channelPayments'),
        content: <Channels />,
        testId: 'tab-channel-payments',
      })
    }

    return tabList
  }, [enableUsLaunchRestrictions, canViewWallets, t])

  if (!enableConsolidatedPayments) {
    return <CryptoPayments />
  }

  return <Tabs tabs={tabs} defaultTabId={defaultTab} />
}
